'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { isExternalLink } from '../../helpers/isExternalLink.js';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { getVisibilityStyle } from '../../mixins/getVisibilityStyle.js';
import { keyboardFocusShadow } from '../../mixins/keyboardFocus.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { useTitanRouter } from '../../router/hooks/useTitanRouter.js';
import { Text } from '../Text/Text.js';

const StyledText = styled(Text).withConfig({
  componentId: "sc-1vn7cti-0"
})(["align-self:stretch;", ";"], ({
  isVisible
}) => typeof isVisible !== 'undefined' && getVisibilityStyle(isVisible));
const Button = styled.button.withConfig({
  shouldForwardProp: (prop, defaultValidationFn) => defaultValidationFn(prop)
}).withConfig({
  componentId: "sc-1vn7cti-1"
})(["border-radius:", ";border:none;outline:none;display:inline-flex;flex-direction:column;gap:4px;align-items:center;justify-content:center;cursor:pointer;font-size:inherit;", " ", " ", " ", " ", ""], ({
  theme,
  rounding
}) => rounding && css(["", ""], theme.components.iconButton.borderRadius[rounding]), ({
  isInvisible
}) => isInvisible && css(["visibility:hidden;pointer-events:none;"]), ({
  hasBackground,
  hasBackgroundOnHover,
  theme,
  variant
}) => css(["color:", ";background-color:", ";", ""], theme.components.iconButton.variant[variant].iconColor, hasBackground ? theme.components.iconButton.variant[variant].backgroundColor : 'transparent', hasBackgroundOnHover && css(["&:hover{background-color:", ";}"], theme.components.iconButton.variant[variant].backgroundColor)), keyboardFocusShadow(), ({
  theme,
  variant,
  isDisabled
}) => isDisabled && css(["pointer-events:none;cursor:not-allowed;color:", ";"], theme.components.iconButton.variant[variant].iconColorDisabled), ({
  padding
}) => padding && css(["", ""], spaceProp(padding, 'padding')));
const IconButton = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      children,
      icon,
      isRounded = true,
      size,
      variant = 'primary',
      isInvisible = false,
      label,
      isDisabled,
      isLabelVisible,
      testId = 'iconButton',
      type = 'button',
      href
    } = _a,
    props = __rest(_a, ["children", "icon", "isRounded", "size", "variant", "isInvisible", "label", "isDisabled", "isLabelVisible", "testId", "type", "href"]);
  const {
    linkWrapper
  } = useTitanRouter();
  const isLink = !!href;
  const renderAs = isLink ? 'a' : 'button';
  const rel = href && isExternalLink(href) ? 'noopener noreferrer' : undefined;
  const target = href && isExternalLink(href) ? '_blank' : undefined;
  const rounding = isRounded && (!children ? 'full' : 'subtle');
  const button = jsxs(Button, Object.assign({
    ref: ref,
    "aria-hidden": !!isInvisible,
    "aria-label": label,
    as: renderAs,
    "data-test-id": testId,
    disabled: isDisabled,
    href: href,
    isDisabled: isDisabled,
    isInvisible: isInvisible,
    rel: rel,
    rounding: rounding || undefined,
    tabIndex: isInvisible ? -1 : 0,
    target: target,
    type: href ? undefined : type,
    variant: variant
  }, props, {
    children: [icon && React.cloneElement(icon, {
      width: size,
      height: size
    }), children && jsx(StyledText, {
      isTruncated: true,
      isVisible: isLabelVisible,
      type: "labelTiny",
      children: children
    })]
  }));
  if (isLink) {
    return linkWrapper(button);
  }
  return button;
}, {
  name: 'IconButton'
});

export { IconButton };
//# sourceMappingURL=IconButton.js.map
